// Check if an image loads by setting a status of: 'ok' or 'error'
// path: string
export const checkIfImageLoads = path =>
  new Promise(resolve => {
      const img = new Image()
      img.onload = () => resolve({path, status: 'ok'})
      img.onerror = () => resolve({path, status: 'error'})
      img.src = path
  })

/*
  Check if all images loaded by stating a status, return callback
  callback: function,
  paths: array of strings image src paths, spread
*/
export const checkAllImagesLoaded = (callback, ...paths) => Promise.all(paths.map(checkIfImageLoads)).then((newPaths) => callback(newPaths))

/*
  Return only loaded images: status = ok
*/
export const filterOnlyLoadedImages = (callback, ...paths) => {
   Promise.all(paths.map(checkIfImageLoads)).then((newPaths) => {
    var loaded = newPaths.filter((path) => {
      return path.status == "ok"
    })
     callback(loaded)
   })
}
